/**
 * 10.5U — TUTORIAL contextual. Nada de tela cheia de texto: a dica aparece UMA vez, no
 * momento em que a mecânica acontece (saiu da base, pegou a 2ª arma, subiu de nível...).
 * O que já foi visto fica salvo no progresso, então não repete em outra sessão.
 */
export type TipId =
  | "move"
  | "leaveBase"
  | "chain"
  | "levelup"
  | "elite"
  | "mission"
  | "altar"
  | "map"
  | "shop"
  | "territory"
  | "death";

export class Tutorial {
  private readonly seen = new Set<string>();
  private cooldown = 0;
  private readonly queue: TipId[] = [];

  constructor(private readonly present: (id: TipId) => void) {}

  /** Dispara a dica (uma vez na vida). Se outra acabou de aparecer, entra na fila. */
  fire(id: TipId): void {
    if (this.seen.has(id)) return;
    this.seen.add(id);
    if (this.cooldown > 0) {
      this.queue.push(id);
      return;
    }
    this.cooldown = 4.2;
    this.present(id);
  }

  /** Espaça as dicas para não empilharem banner em cima de banner. */
  update(dt: number): void {
    if (this.cooldown <= 0) return;
    this.cooldown -= dt;
    if (this.cooldown <= 0 && this.queue.length > 0) {
      const next = this.queue.shift()!;
      this.cooldown = 4.2;
      this.present(next);
    }
  }

  /** 10.9IH — registra algo como "ja visto" sem mostrar nada (o tour guiado grava a marca dele
   *  aqui pra sobreviver ao proximo `showTip`, que reescreve a lista a partir deste snapshot). */
  mark(id: string): void {
    this.seen.add(id);
  }

  has(id: TipId): boolean {
    return this.seen.has(id);
  }
  snapshot(): string[] {
    return [...this.seen];
  }
  load(list: string[] | undefined): void {
    this.seen.clear();
    this.queue.length = 0;
    this.cooldown = 0;
    for (const id of list ?? []) if (typeof id === "string") this.seen.add(id);
  }
  reset(): void {
    this.seen.clear();
    this.queue.length = 0;
    this.cooldown = 0;
  }
}
